import { render, staticRenderFns } from "./MultiselectContacts.vue?vue&type=template&id=2818e818&"
import script from "./MultiselectContacts.vue?vue&type=script&lang=js&"
export * from "./MultiselectContacts.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectContacts.vue?vue&type=style&index=0&id=2818e818&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports